import parseFormat from 'moment-parseformat';

export class DateParserController {
  /* @ngInject */
  constructor() {
    this.dateParser = this.dateParser || {};
  }

  read(ngModel, dateString) {
    if (!_.isEmpty(dateString)) {
      let format = parseFormat(dateString, {
        preferredOrder: {
          '/': 'DMY',
          '.': 'DMY',
          '-': 'YMD'
        }
      });
      let date = moment(dateString, format).toDate();
      let now = moment().startOf('day').toDate();
      if (!this.dateParser.future && date.getTime() > now.getTime()) {
        date = now;
      }
      ngModel.$setViewValue(date);
      ngModel.$commitViewValue();
    }
  }
}
;

export function DateParserDirective() {
  // see: https://github.com/angular/angular.js/blob/cdc4d485a6daa0c74e5d07d8def2a3ee68d93d13/src/ng/directive/input.js#L861
  return {
    require: '^ngModel',
    restrict: 'A',
    controller: DateParserController,
    controllerAs: 'vm',
    scope: {
      dateParser: '=dateParser'
    },
    bindToController: true,
    link: function (scope, element, attrs, ngModel) {
      if (!ngModel) return;

      ngModel.$render = function () {
        if (ngModel.$viewValue) {
          let val = ngModel.$viewValue;
          if (angular.isString(val)) {
            val = new Date(val);
          }

          element.val(moment(val).format(scope.vm.dateParser.customFormat ? scope.vm.dateParser.customFormat : 'D.MM.YYYY'));
        } else {
          element.val('');
        }
      };

      element
        .focus(function (event) {
          element.select();
        })
        .blur(function (event) {
          scope.$apply(() => scope.vm.read(ngModel, element.val()));
          ngModel.$render();
        })
        .keyup(function (event) {
          if (event.keyCode == 13) {
            element.blur();
          }
        });
    }
  }
}

export default angular.module('app.datetime.dateParser', [])
  .directive('dateParser', DateParserDirective)



/** WEBPACK FOOTER **
 ** ./src/common/datetime/date-parser.js
 **/